import React, { memo } from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';
export function WarningSection() {
  return <section className="py-20 bg-marron text-white" data-id="element-294">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-295">
        <div className="text-center mb-12" data-id="element-296">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-mostaza mb-6" data-id="element-297">
            Tu Cuerpo Te Está Hablando.
            <br data-id="element-298" />
            ¿Lo Estás Escuchando?
          </h2>
          <p className="text-lg text-crema/80 max-w-3xl mx-auto" data-id="element-299">
            Las señales cotidianas como el cansancio o la hinchazón parecen
            inofensivas — pero suelen ser las primeras alarmas que tu cuerpo
            manda antes de que algo más grave se instale.
          </p>
        </div>

        <h3 className="text-xl font-bold text-oliva-light mb-6 flex items-center" data-id="element-300">
          <AlertTriangle className="w-6 h-6 mr-2" data-id="element-301" />
          Las Señales de Alerta Tempranas
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-302">
          {[{
          title: 'Te despertás cansada',
          text: 'Después de 8 horas seguís sin energía. Puede ser fatiga adrenal o mala absorción de nutrientes.'
        }, {
          title: 'Tu digestión está mal',
          text: 'Hinchazón, gases o malestar post-comida. Tu sistema digestivo está pidiendo apoyo.'
        }, {
          title: 'Dolés sin razón aparente',
          text: 'Articulaciones, espalda, músculos. El dolor que persiste suele ser inflamación disfrazada.'
        }, {
          title: 'Niebla mental constante',
          text: 'Olvidás palabras, perdés el hilo. Tu cerebro no está recibiendo el soporte que necesita.'
        }].map((item, i) => <div key={i} className="bg-crema/5 border-l-4 border-terracota p-5 rounded-r-lg" data-id="element-303">
              <h4 className="font-bold text-terracota-light text-lg mb-2" data-id="element-304">
                {item.title}
              </h4>
              <p className="text-crema/70 text-sm" data-id="element-305">{item.text}</p>
            </div>)}
        </div>

        <h3 className="text-xl font-bold text-terracota mb-6" data-id="element-306">
          🚨 Qué Pasa Si Esperás Demasiado
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-307">
          {[{
          title: 'Inflamación Crónica',
          text: "Ese 'dolorcito' se convierte en artritis o brotes autoinmunes que ya no tienen vuelta atrás fácil."
        }, {
          title: 'Órganos con Sobrecarga',
          text: 'Hígado, riñones e intestino no pueden detoxificar. Las toxinas se acumulan y la energía cae en picada.'
        }, {
          title: 'Inmunidad Comprometida',
          text: 'Agarrás todo lo que circula y tardás cada vez más en recuperarte.'
        }, {
          title: 'Tu Mente Se Nubla',
          text: 'Niebla mental. Cambios de humor. Pérdida de memoria. Tu cuerpo fuera de sincronía — y tu mente paga el precio.'
        }].map((item, i) => <div key={i} className="bg-black/20 p-5 rounded-lg border border-white/5" data-id="element-308">
              <h4 className="font-bold text-mostaza text-sm uppercase tracking-wider mb-2" data-id="element-309">
                {item.title}
              </h4>
              <p className="text-crema/60 text-sm" data-id="element-310">{item.text}</p>
            </div>)}
        </div>

        <div className="text-center bg-white/5 p-8 rounded-2xl border border-white/10" data-id="element-311">
          <p className="text-xl font-bold text-mostaza mb-2" data-id="element-312">
            ✅ La buena noticia: todo esto es tratable naturalmente.
          </p>
          <p className="text-crema/80 mb-8" data-id="element-313">
            El Manual de Sanación Natural te enseña cómo hacerlo, paso a paso,
            desde tu cocina.
          </p>

          <a href="#oferta" className="inline-flex items-center px-8 py-3 bg-oliva hover:bg-oliva-light text-white font-bold rounded-lg transition-colors" data-id="element-314">
            🌿 QUIERO EMPEZAR A SENTIRME BIEN HOY
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-315" />
          </a>
        </div>
      </div>
    </section>;
}